import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Divider, Checkbox } from 'antd';
import {
  FileSearchOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import {
  CustomButton,
  CustomTable,
  CustomTabs,
  CustomText,
  CustomTextArea,
  FormInput,
} from '../../../../components';
import ModalManageItem from '../components/ByRoles/ModalManageItem';
import ModalAddItemRolActivo from '../components/ByRoles/ModalAddItemRolActivo';
import { Asset } from '../components/ModalAddItemActivo';
import { Asset as assetRol } from '../components/ByRoles/ModalAddItemRolActivo';
import ModalGestionEstados from '../components/ByRoles/ModalGestionEstados';
import { Item, TransfersRequest } from '../../../Transfers/types/transfers-response';
import { DownloadFileReqAPI } from '../../../../share/api/downloadFileService';

interface InventoryManageViewProps {
  detailData?: TransfersRequest;
  setFooterLeft: (footer: React.ReactNode) => void;
  onDocuments: (id: string[]) => void;
  entryStates?: any;
  formikSolicitud?: any;
  onViewDetail: (id: string) => void;
  onSuccess?: () => void;
  shouldReset?: boolean;
  updates: { id: string; status_id: string; observations: string }[];
  setUpdates: React.Dispatch<
    React.SetStateAction<
      { id: string; status_id: string; observations: string }[]
    >
  >;
  generalObservations: string;
  setGeneralObservations: (obs: string) => void;
  dataItems?: Item[];
  isLoadingItems?: boolean;
}

const InventoryManageView: React.FC<InventoryManageViewProps> = ({
  detailData,
  setFooterLeft,
  onDocuments,
  formikSolicitud,
  onSuccess,
  shouldReset,
  setUpdates,
  generalObservations,
  setGeneralObservations,
  entryStates,
  dataItems,
  isLoadingItems,
}) => {
  const [isRoleTechnician, setIsRoleTechnician] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<Asset | null>(null);
  const [isModalGestionActivo, setIsModalGestionActivo] = useState(false);
  const [isModalGestionActivoIds, setIsModalGestionActivoIds] = useState(false);

  const [selectedAssetRol, setSelectedAssetRol] = useState<assetRol | null>(
    null
  );
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  
  const [searchText, setSearchText] = useState('');

  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  
  useEffect(() => {
    if (shouldReset) {
      setSearchText('');
      setFilteredData(dataItems || []);
      setSelectedIds([]);
    }
  }, [shouldReset]);

  const status = [
    { id: 15, status: 'Recibido' },
    { id: 10, status: 'Rechazado' },
  ];
  const handleUpdateItem = (
    updatesSetter: React.Dispatch<React.SetStateAction<{ id: string; status_id: string; observations: string }[]>>,
    filteredDataSetter: React.Dispatch<React.SetStateAction<any[]>>,
    itemUpdate: { id: number; status_id: number; observations: string },
    entryStates?: any[]
  ) => {
    const idStr = itemUpdate.id.toString();
    const statusIdStr = itemUpdate.status_id.toString();
  
    updatesSetter((prev) => {
      const filtered = prev.filter((u) => u.id !== idStr);
      return [...filtered, { id: idStr, status_id: statusIdStr, observations: itemUpdate.observations }];
    });
  
    const updateFn = (items: any[]) =>
      items.map((item) => {
        if (String(item.id) === idStr || String(item.itemable_id) === idStr) {
          return {
            ...item,
            status: entryStates?.find((e) => e.id.toString() === statusIdStr)?.name || 'Recibido',
            observations: itemUpdate.observations,
          };
        }
        return item;
      });

    setCurrentItems((prev) => updateFn(prev));
    filteredDataSetter((prev) => updateFn(prev));
  };
  

  useEffect(() => {
    setFooterLeft(
      <Row justify="space-between" align="middle" style={{ width: '100%' }}>
        {/* Botones a la izquierda */}
        <Col>
          <Row gutter={16}>
            <Col>
              <CustomButton
                label="Generar Comprobante"
                disabled={Number(detailData?.status_id) !== 7}
                onClick={handleGeneratePDF}
                icon={<FileSearchOutlined />}
                size="middle"
                buttonType="secondary"
              />
            </Col>
            <Col>
              <CustomButton
                label="Descargar Documentos"
                disabled={
                  !detailData?.documents || detailData.documents.length === 0
                }
                onClick={() => {
                  if (detailData?.id) {
                    onDocuments([detailData.id.toString()]);
                  }
                }}
                icon={<DownloadOutlined />}
                size="middle"
                buttonType="secondary"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );

    const storedToken = localStorage.getItem('auth');

    if (storedToken) {
      try {
        const parsedToken = JSON.parse(storedToken);
        const role = parsedToken?.role?.toLowerCase();
        setIsRoleTechnician(role === 'tecnico');
      } catch (error) {
        console.error('Error al parsear el token:', error);
        setIsRoleTechnician(false);
      }
    } else {
      setIsRoleTechnician(false);
    }
  }, [setFooterLeft, detailData, onDocuments]);

  const handleGeneratePDF = async () => {
  if (!detailData?.id_petition) {
    console.error('No hay ID de concepto para generar el PDF.');
    return;
  }

  try {
    await DownloadFileReqAPI.downloadPDF(detailData.id_petition.toString());
  } catch (error) {
    console.error('Error al generar el PDF:', error);
  }
};


  useEffect(() => {
    if (dataItems?.length) {
      setCurrentItems(dataItems);
      setFilteredData(dataItems);
    }
  }, [dataItems]);

  const handleManageItem = (item: any) => {
    setSelectedItem({
      ...item,
      id_asset: detailData?.id,
      ticket: detailData?.ticket,
    });
    setIsModalGestionActivo(true);
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value || '';
    setSearchText(value);
  
    if (!value) {
      setFilteredData(currentItems);
      return;
    }
  
    const valueLower = value.toLowerCase();
  
    const filtered = currentItems.filter((item) => {
      return (
        item.asset?.toLowerCase().includes(valueLower) ||        
        item.plate_code?.toLowerCase().includes(valueLower) ||
        item.status?.toLowerCase().includes(valueLower) ||
        item.observations?.toLowerCase().includes(valueLower)
      );
    });
  
    setFilteredData(filtered);
  };
  

  const historyColumns = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Realizado por',
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: 'Observaciones',
      dataIndex: 'observations',
      key: 'observations',
    },
    {
      title: 'Estado',
      dataIndex: 'comment',
      key: 'comment',
    },
  ];

  const documentColumns = [
    {
      title: 'Item',
      dataIndex: 'index',
      key: 'index',
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <Fragment>
      {/* Información General */}
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Solicitante:" strong fontSize="small" />
            <CustomText
              text={detailData?.requester || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Dependencia:" strong fontSize="small" />
            <CustomText
              text={detailData?.dependency || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Nuevo responsable:" strong fontSize="small" />
            <CustomText
              text={detailData?.new_responsible || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
         <Col span={6}>
            <div className="mb-4">
              <CustomText text="Dependencia nuevo responsable:" strong fontSize="small" />
              <CustomText
                text={detailData?.new_dependency || 'Por definir'}
                fontSize="middle"
              />
            </div>
          </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Fecha solicitud:" strong fontSize="small" />
            <CustomText
              text={detailData?.query_date || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
        <Col span={6}>
          <div className="mb-4">
            <CustomText text="Estado de solicitud:" strong fontSize="small" />
            <CustomText
              text={detailData?.status || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="mb-4">
            <CustomText text="Observaciones:" strong fontSize="small" />
            <CustomText
              text={detailData?.observations || 'Por definir'}
              fontSize="middle"
            />
          </div>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col span={24}>
          <div className="mb-4">
            <CustomText
              text="Observaciones de recepción (opcional):"
              strong
              fontSize="small"
            />
            <CustomTextArea
              label=""
              name="reason"
              value={generalObservations}
              onChange={(e) => setGeneralObservations(e.target.value)}
            />
          </div>
        </Col>
      </Row>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: '20px' }}
      >
        <Col xs={24} sm={12}>
          <CustomText text="Listado de activos" strong fontSize="big" />
        </Col>

        <Col xs={24} sm={12} style={{ textAlign: 'right' }}>
          <FormInput
            label="Buscador"
            placeholder="Buscar..."
            value={searchText}
            onChange={handleSearch}
            name="search"
          />
        </Col>
      </Row>

      <Divider />

      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col></Col>
        <Col>
          <CustomButton
            label="Gestionar estados"
            onClick={() => setIsModalGestionActivoIds(true)}
            size="middle"
            disabled={selectedIds.length === 0}
          />
        </Col>
      </Row>

      <CustomTabs
        defaultActiveKey="1"
        items={[
          {
            key: '1',
            label: <span>Items</span>,
            children: (
  <>
    <Row justify="space-between" align="middle" className="mb-3 ml-1 pb-1">
      <Col>
        <Checkbox
          indeterminate={
            !!selectedIds.length &&
            selectedIds.length < filteredData.length
          }
          checked={
            selectedIds.length === filteredData.length &&
            filteredData.length > 0
          }
          onChange={(e) => {
            if (e.target.checked) {
              const allKeys = filteredData.map((item) => item.id);
              setSelectedIds(allKeys);
            } else {
              setSelectedIds([]);
            }
          }}
        >
          Seleccionar todos
        </Checkbox>
      </Col>
    </Row>

    <CustomTable
      loading={isLoadingItems}
      rowSelection={{
        selectedRowKeys: selectedIds,
        type: 'checkbox',
        onChange: (selectedRowKeys) =>
          setSelectedIds(selectedRowKeys as number[]),
      }}
      columns={[
        { title: 'Item', dataIndex: 'id', key: 'id' },
        {
          title: 'Código/placa',
          dataIndex: 'plate_code',
          key: 'plate_code',
        },
        {
          title: 'Descripción',
          dataIndex: 'asset',
          key: 'asset',
        },
        {
          title: 'Clase de activo',
          dataIndex: 'class',
          key: 'class',
          render: (_: any, record: any) =>
            `${record.class_code} - ${record.class}`,
        },
        {
          title: 'Artículo',
          key: 'item',
          render: (_: any, record: any) =>
            `${record.item_code} - ${record.item}`,
        },
        {
          title: 'Adiciones',
          dataIndex: 'assets_count',
          key: 'assets_count',
        },
        {
          title: 'Estado del elemento',
          dataIndex: 'status',
          key: 'status',
        },
        {
          title: 'Observaciones',
          dataIndex: 'observations',
          key: 'observations',
          render: (text: string) => text || 'Sin registro',
        },
        {
          title: 'Acciones',
          key: 'actions',
          render: (_, record) => (
            <CustomButton
              label="Gestionar"
              onClick={() => handleManageItem(record)}
              size="middle"
            />
          ),
        },
      ]}
      dataSource={filteredData || []}
      rowKey="id"
    />
  </>
)

          },
          {
            key: '2',
            label: <span>Documentos</span>,
            children: (
              <CustomTable
                dataSource={detailData?.documents?.map((doc, index) => ({
                  key: index,
                  createdAt: doc.created_at,
                  name: doc.url?.split('/').pop(),
                  link: doc.url,
                }))}
                columns={documentColumns}
                pagination={false}
              />
            ),
          },
          {
            key: '3',
            label: <span>Historial de la solicitud</span>,
            children: (
              <CustomTable
                columns={historyColumns}
                dataSource={detailData?.history?.map((item, index) => ({
                  key: index,
                  date: item.date,
                  comment: item.comment,
                  observations: item.observations,
                  user: item.user_document + '' + ' - ' + item.user,
                }))}
                pagination={false}
              />
            ),
          },
        ]}
      />

      {isModalOpen && (
        <ModalAddItemRolActivo
          isModalAddItem={isModalOpen}
          setIsModalAddItem={setIsModalOpen}
          formik={formikSolicitud}
          onAddItem={() => {}}
          selectedAssetId={selectedAssetRol}
        />
      )}

      {isModalGestionActivo && (
        <ModalManageItem
          isModalManageItem={isModalGestionActivo}
          setIsModalManageItem={setIsModalGestionActivo}
          selectedItem={selectedItem}
          onSuccess={onSuccess}
          onClose={() => setIsModalGestionActivo(false)}
          onSave={(itemUpdate) => {
            handleUpdateItem(
              setUpdates,
              setFilteredData,
              itemUpdate,
              entryStates
            );
          }}
        />
      )}
      {isModalGestionActivoIds && (
        <ModalGestionEstados
          isOpen={isModalGestionActivoIds}
          onClose={() => setIsModalGestionActivoIds(false)}
          selectedIds={selectedIds}
          assetId={detailData?.id?.toString() || ''}
          onSuccess={onSuccess}
          onSave={(updatesArray) => {
            updatesArray.forEach((itemUpdate) => {
              handleUpdateItem(
                setUpdates,
                setFilteredData,
                itemUpdate,
                entryStates
              );
            });
          }}
        />
      )}
    </Fragment>
  );
};

export default InventoryManageView;